export const STATUS_ANALISE_PENDENTE = 0;
export const STATUS_VISTA_PARA_ARREMATANTE = 1;
export const STATUS_MOVIDA_PARA_OUTRO_USUARIO = 100;

export const Status = [
  {label: 'Pendente', value: STATUS_ANALISE_PENDENTE},
  {label: 'Vistas', value: STATUS_VISTA_PARA_ARREMATANTE},
  {label: 'Movida para outro usuário', value: STATUS_MOVIDA_PARA_OUTRO_USUARIO}
]
